<script>
    import { preventDefault } from 'svelte/legacy';
    import { onMount } from 'svelte';
    /* Firebase */
    import { auth } from '@app/configs/firebase.js';
    import db from '@app/configs/firestore.js';
    import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
    /* 3rd Party Lib */
    import {
        Circle
    } from 'svelte-loading-spinners';
    import * as m from "@app/paraglide/messages.js";

    let jobUpdate = $state(true);
    let teamUpdate = $state(true);
    let isLoading = $state(true);
    let jobUpdateLoading = $state(false);
    let teamUpdateLoading = $state(false);
    let error = $state(null);
    
    let userId = auth.currentUser.uid;
    let userDbRef = doc(db, "users", userId);

    async function updateNotificationSettings(settingType = 'all') {
        try {
            // Set loading state for the specific setting
            if (settingType === 'jobUpdate' || settingType === 'all') {
                jobUpdateLoading = true;
            }
            if (settingType === 'teamUpdate' || settingType === 'all') {
                teamUpdateLoading = true;
            }

            await updateDoc(userDbRef, {
                'notifications.jobUpdate': jobUpdate,
                'notifications.teamUpdate': teamUpdate
            });
        } catch(err) {
            error = err;
            console.log(err, err.message);
        } finally {
            // Reset loading state
            if (settingType === 'jobUpdate' || settingType === 'all') {
                jobUpdateLoading = false;
            }
            if (settingType === 'teamUpdate' || settingType === 'all') {
                teamUpdateLoading = false;
            }
        }
    }       

    async function setup() {
        isLoading = true;
        error = null;
        
        try {
            let userDoc = await getDoc(userDbRef);
            if (!userDoc.exists()) {
                console.warn(`No user document exists for current user: ${userId}`);
                await setDoc(userDbRef, {
                    notifications: {
                        jobUpdate: true,
                        teamUpdate: true,
                    },
                }, { merge: true });
                return;
            }

            let userInfo = userDoc.data();
            jobUpdate = userInfo.notifications ? userInfo.notifications.jobUpdate : true;
            teamUpdate = userInfo.notifications ? userInfo.notifications.teamUpdate : true;
        } catch(err) {
            error = err;
            console.log(err, err.message);
        } finally {
            isLoading = false;
        }   
    }

    onMount(() => {
        setup();
    });
</script>    

<h5 id="notificationSettingsTitle">{m.options_notifications_title()}</h5>
<p id="notificationSettingsDesc" class="small text-muted">{m.options_notifications_desc()}</p>

{#if error}
    <div class="d-flex justify-content-center align-items-center p-3">
        <p class="text-danger m-0">{m.options_notifications_error_loading()}</p>
    </div>
{:else}
    <form onsubmit={preventDefault(() => updateNotificationSettings('all'))} aria-labelledby="notificationSettingsTitle" aria-describedby="notificationSettingsDesc">
        <div class="mb-3 form-check form-switch">
            <input type="checkbox" class="form-check-input" id="jobUpdateCheck" 
                bind:checked={jobUpdate} 
                onchange={() => updateNotificationSettings('jobUpdate')}
                disabled={isLoading || jobUpdateLoading}
                aria-labelledby="jobUpdateCheckLabel">
            <label id="jobUpdateCheckLabel" class="form-check-label" for="jobUpdateCheck">
                {m.options_notifications_job_completion()} 
                {#if isLoading || jobUpdateLoading}
                    <span class="spinner-container ms-2" style="display: inline-block; width: 15px; height: 15px;">
                        <Circle size="15" color="#1eb4b2" unit="px" />
                    </span>
                {:else}
                    <i class="bi bi-info-circle" title={m.options_notifications_job_completion_help()}></i>
                {/if}
            </label>
        </div>
        <div class="mb-3 form-check form-switch">
            <input type="checkbox" class="form-check-input" id="teamUpdateCheck" 
                bind:checked={teamUpdate} 
                onchange={() => updateNotificationSettings('teamUpdate')}
                disabled={isLoading || teamUpdateLoading}
                aria-labelledby="teamUpdateCheckLabel">
            <label id="teamUpdateCheckLabel" class="form-check-label" for="teamUpdateCheck">
                {m.options_notifications_team_member_added()} 
                {#if isLoading || teamUpdateLoading}
                    <span class="spinner-container ms-2" style="display: inline-block; width: 15px; height: 15px;">
                        <Circle size="15" color="#1eb4b2" unit="px" />
                    </span>
                {:else}
                    <i class="bi bi-info-circle" title={m.options_notifications_team_member_added_help()}></i>
                {/if}
            </label>
        </div>
    </form>
{/if}
